module.exports = __webpack_public_path__ + "static/media/jobSearchFormImage.b735751a.svg";